<template>
  <Link
    v-for="model in resource.data"
    :key="model"
    :href="route(`${routePrefix}.${resourceType}.show`, model.data.id)"
    :style="getStyle(model, options.placeholder_image)"
    class="d-flex align-items-end text-decoration-none text-white tile"
  >
    <div
      :title="model.data.attributes[options.title_key]"
      class="w-100 p-3 text-end"
      style="background: rgba(0, 0, 0, 0.25)"
    >
      <h4 class="mb-0 product-name text-truncate">{{ model.data.attributes[options.title_key] }}</h4>
      <small>
        {{ options.subtitle_prefix }}
        <presentation-field
          :column="options.subtitle_key"
          :column-type="meta.columns[options.subtitle_key]"
          :mutation="meta.elementTypes[options.subtitle_key].collection"
          :resource-type="resourceType"
          :show-id="$page.props.user.roles.includes('tech')"
          :value="model.data.attributes[options.subtitle_key]"
        ></presentation-field>
      </small>
    </div>
  </Link>
</template>

<script>
import PresentationField from '@kanrisha/components/Presentation/PresentationField';
import { Link } from '@inertiajs/vue3';
import useResource from '@kanrisha/composables/useResource';

export default {
  components: {
    Link,
    PresentationField,
  },
  props: {
    options: { type: Object, default: () => {} },
    resource: { type: Object, default: () => {} },
    name: { type: String, default: 'default' },
    pagination: { type: Boolean, default: () => true }, // deprecated: this should go on options or config
  },
  emits: ['addToast', 'updatePicked', 'update:data', 'update:relation', 'trigger:refresh'],
  setup(props) {
    const { meta, resourceType } = useResource(props, props.resource);

    const getStyle = (model, placeholder) => {
      let imageUrl = model.data.attributes.image_preview_url || placeholder;

      return {
        background: `url('${imageUrl}') no-repeat center/cover`,
        aspectRatio: 1,
      };
    };

    return {
      getStyle,
      meta,
      resourceType,
    };
  },
};
</script>
